export default __webpack_public_path__ + "static/media/bg-small.c57805b5.jpg";